import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Exchange({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M2.86201 6.86174C2.60166 7.12208 2.60166 7.54419 2.86201 7.80454L7.52868 12.4712L8.47149 11.5284L4.94289 7.99981L20.6667 7.99981V6.66647L4.94289 6.66647L8.47149 3.13788L7.52868 2.19507L2.86201 6.86174Z"
        fill={iconColor}
      />
      <Path
        d="M21.1382 16.1951C21.3985 16.4554 21.3985 16.8775 21.1382 17.1379L16.4715 21.8045L15.5287 20.8617L19.0573 17.3331H3.33341L3.33341 15.9998H19.0573L15.5287 12.4712L16.4715 11.5284L21.1382 16.1951Z"
        fill={iconColor}
      />
    </Svg>
  );
}
